import React, {
  ComponentType,
  createElement,
  lazy,
  LazyExoticComponent,
  ReactElement
} from 'react';

import ErrorMessage from '@buyside/components/presentation/ErrorMessage/errorMessage';
import LoadingSpinner from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';

import rollbar from '@assets/util/rollbar';

const LazyLoadErrorMessage = (): ReactElement => (
  <ErrorMessage title="Uh Oh...">
    Please refresh the page. If the problem persists contact{' '}
    <a href="mailto:support@sumzero.com">support@sumzero.com</a>.
  </ErrorMessage>
);

const lazyWithRetry = (
  componentImport: () => Promise<{ default: ComponentType }>
): LazyExoticComponent<ComponentType> =>
  lazy(() => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    return componentImport()
      .then(component => {
        window.localStorage.setItem('page-has-been-force-refreshed', 'false');
        return component;
      })
      .catch(error => {
        if (pageHasAlreadyBeenForceRefreshed) {
          rollbar.error(error, 'Page failed to load.');

          return {
            default: () => createElement(LazyLoadErrorMessage)
          };
        } else {
          window.localStorage.setItem('page-has-been-force-refreshed', 'true');
          window.location.reload();

          return {
            default: () =>
              createElement(LoadingSpinner, {
                type: 'default',
                size: 'medium',
                inlineBlock: false
              })
          };
        }
      });
  });

export default lazyWithRetry;
